import {Component, Input} from '@angular/core';
import {ContextMenuItem} from '../../types/context-menu-item';
import {ContextMenuService} from '../../providers/context-menu.service';
import {ContexrService} from '../../providers/contexr.service';

@Component({
  selector: 'ctx-context-menu-item',
  template: `<li (click)="act($event)" class="context-list-item">
  <div class="flex-container">
    <div class="icon-holder">
      <i *ngIf="item.icon" class="{{item.icon}}"></i>
    </div>
    <span class="context">{{item.text}}</span>
    <span style="flex: 1 1 auto;"></span>
    <span class="shortcut">{{item.hotkey}}</span>
  </div>
</li>
`,
  styles: [`.icon-holder{width:15px;border-right:1px solid rgba(0,0,0,.31)}.context-list-item{margin:0;padding:0}.context,.icon-holder,.shortcut{padding:3px 5px;line-height:1.2em}`]
})
export class ContextMenuItemComponent {

  @Input() item: ContextMenuItem;

  constructor(
    private contextMenuService: ContextMenuService,
    private contexr: ContexrService
  ) { }

  /**
   * Call an action and close the context menu
   * @param context
   */
  public act(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.contexr.act(this.item);
    this.contextMenuService.close();
  }
}
